import React, { useEffect } from 'react';

const PublicBacQueryPage = ({ affiliateDnsName }) => {
  useEffect(() => {
    const networkName = affiliateDnsName?.toLowerCase();
    let redirectionLink;

    if (networkName === 'cigna') {
      redirectionLink = `https://cigna-price-transparency.mpoweredhealth.com/find-care`;
    } else if (networkName === 'medcost') {
      redirectionLink = `https://medcost-price-transparency.mpoweredhealth.com/find-care`;
    } else if (networkName === 'mmo') {
      redirectionLink = `https://mmo-price-transparency.mpoweredhealth.com/find-care`;
    } else {
      redirectionLink = window.location.href
        .replace('-member.', '-price-transparency.')
        .replace('/activeplanspricelist', '/find-care');
    }

    window.location.href = redirectionLink;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default PublicBacQueryPage;
